export default __webpack_public_path__ + "static/media/point-speeding.976eaa67.svg";